import countryList from 'react-select-country-list';

export const countryCodes: string[] = countryList().getValues();
